import { useCallback, useState } from 'react';
/**
 * Force re-renders Component.
 */
export function useForceUpdate(): () => void {
  const [, updateState] = useState(0);
  return useCallback(() => updateState(increment), []);
}

function increment(n: number): number {
  return (n + 1) % 1000000;
}
